// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const DashboardIcon = props => <Icon {...props} dangerouslySetIcon={'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M22 14a1 1 0 01-1-1 9 9 0 00-18 0 1 1 0 01-2 0 11 11 0 0122 0 1 1 0 01-1 1z"/><path d="M12 22a5 5 0 115-5 5 5 0 01-5 5zm0-8a3 3 0 103 3 3 3 0 00-3-3z"/><path d="M12 14a1 1 0 01-1-1V9a1 1 0 012 0v4a1 1 0 01-1 1z"/></svg>'} />;

DashboardIcon.displayName = 'DashboardIcon';

export default DashboardIcon;
